import { LocationStrategy } from '@angular/common';
import { Directive, HostBinding, HostListener, Input, OnChanges, OnDestroy } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, UrlTree } from '@angular/router';

import { RouteService } from '../services/route.service';

@Directive({selector: ':not(a)[route]'})
export class RouterNamedLink {

    @Input() queryParams: { [k: string]: any };
    @Input() fragment: string;
    @Input() preserveQueryParams: boolean;
    @Input() preserveFragment: boolean;
    @Input() skipLocationChange: boolean;
    @Input() replaceUrl: boolean;

    private commands: any[] = [];

    constructor(private router: Router, private activatedRoute: ActivatedRoute, protected routeService: RouteService) {
    }

    @Input()
    set route(route: string | Array<string>) {

        let parameters = null;
        let name       = null;
        let outlet     = null;

        if (route instanceof Array) {

            name       = route[0];
            parameters = route[1];
            outlet     = route[2];

        } else {
            name = route;
        }

        if (name.charAt(0) === '/') {
            name = name.slice(1);
        }

        const path = this.routeService.route(name, parameters) ? this.routeService.route(name, parameters) : '/';

        this.commands = [path];

    }

    @HostListener('click')
    onClick(): boolean {

        const extras = {
            skipLocationChange: attrBoolValue(this.skipLocationChange),
            replaceUrl: attrBoolValue(this.replaceUrl),
        };

        this.router.navigateByUrl(this.urlTree, extras);

        return true;

    }

    get urlTree(): UrlTree {

        return this.router.createUrlTree(this.commands, {
            relativeTo: this.activatedRoute,
            queryParams: this.queryParams,
            fragment: this.fragment,
            preserveQueryParams: attrBoolValue(this.preserveQueryParams),
            preserveFragment: attrBoolValue(this.preserveFragment),
        });

    }

}

@Directive({selector: 'a[route]'})
export class RouterNamedLinkWithHref implements OnChanges, OnDestroy {

    @HostBinding('attr.target') @Input() target: string;

    @Input() queryParams: { [k: string]: any };
    @Input() fragment: string;
    @Input() preserveQueryParams: boolean;
    @Input() preserveFragment: boolean;
    @Input() skipLocationChange: boolean;
    @Input() replaceUrl: boolean;

    private commands: any[] = [];
    private subscription;

    // the url displayed on the anchor element.
    @HostBinding() href: string;

    constructor(private router: Router, private activatedRoute: ActivatedRoute, private locationStrategy: LocationStrategy, protected routeService: RouteService) {

        this.subscription = router.events.subscribe(s => {

            if (s instanceof NavigationEnd) {
                this.updateTargetUrlAndHref();
            }

        });

    }

    @Input()
    set route(route: string | Array<string>) {

        let parameters = null;
        let name       = null;

        if (route instanceof Array) {

            name       = route[0];
            parameters = route[1];

        } else {
            name = route;
        }

        if (name.charAt(0) === '/') {
            name = name.slice(1);
        }

        const path = this.routeService.route(name, parameters) ? this.routeService.route(name, parameters) : '/';

        this.commands = [path];

    }

    ngOnChanges(changes: {}): any {

        this.updateTargetUrlAndHref();

    }

    ngOnDestroy(): any {

        this.subscription.unsubscribe();

    }

    @HostListener('click', ['$event.button', '$event.ctrlKey', '$event.metaKey'])
    onClick(button: number, ctrlKey: boolean, metaKey: boolean): boolean {

        if (button !== 0 || ctrlKey || metaKey) {
            return true;
        }

        if (typeof this.target === 'string' && this.target != '_self') {
            return true;
        }

        const extras = {
            skipLocationChange: attrBoolValue(this.skipLocationChange),
            replaceUrl: attrBoolValue(this.replaceUrl),
        };

        this.router.navigateByUrl(this.urlTree, extras);

        return false;

    }

    private updateTargetUrlAndHref(): void {

        this.href = this.locationStrategy.prepareExternalUrl(this.router.serializeUrl(this.urlTree));

    }

    get urlTree(): UrlTree {

        return this.router.createUrlTree(this.commands, {
            relativeTo: this.activatedRoute,
            queryParams: this.queryParams,
            fragment: this.fragment,
            preserveQueryParams: attrBoolValue(this.preserveQueryParams),
            preserveFragment: attrBoolValue(this.preserveFragment),
        });

    }
}

function attrBoolValue(s: any): boolean {
    return s === '' || !!s;
}



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/routing/directives/router-named-link.ts